import { TaxRatesContext } from "../providers/TaxRatesProvider";
import { useContext } from "react";

export default function useTaxRatesContext() {
  return useContext(TaxRatesContext);
}
